module.exports = __webpack_public_path__ + "static/img/w3-6.75e7d23.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pagess/gdd102/w3-6.png
// module id = HBMG
// module chunks = 1